export const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.45, ease: 'easeOut' } })
};

export const scaleIn = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: (i = 0) => ({ opacity: 1, scale: 1, transition: { delay: i * 0.07, duration: 0.4, ease: 'easeOut' } })
};

export const getRoleColor = (role) => {
    const r = (role || '').toLowerCase();
    if (r.includes('national')) return '#6366f1'; // Indigo
    if (r.includes('zone')) return '#3b82f6'; // Blue
    if (r.includes('state')) return '#14b8a6'; // Teal
    if (r.includes('leader') || r.includes('middle')) return '#f59e0b'; // Amber
    if (r.includes('frontline')) return '#35693dff'; // Pink
    return '#64748b'; // Slate default
};

export const getRoleLabel = (role) => {
    const r = (role || '').toUpperCase();
    const roleMap = {
        NATIONAL_HEAD: 'National Head',
        NH: 'National Head',
        ZONE_HEAD: 'Zone Head',
        ZH: 'Zone Head',
        STATE_HEAD: 'State Head',
        SH: 'State Head',
        MIDDLE_MANAGER: 'Team Leader',
        TL: 'Team Leader',
        MANAGER: 'Frontline',
        FL: 'Frontline',
        FRONTLINE: 'Frontline'
    };
    return roleMap[r] || role;
};

export const formatPercentage = (val, maxDecimals = 3) => {
    // This will show up to 3 decimals, but only if they are not zero
    // e.g., 10 -> 10%, 10.5 -> 10.5%, 10.5555 -> 10.556%
    const formatted = Number(val.toFixed(maxDecimals));
    return `${formatted}%`;
};

export const renderPieLabel = ({ cx, cy, midAngle, outerRadius, percent }) => {
    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + outerRadius * cos;
    const sy = cy + outerRadius * sin;
    const mx = cx + (outerRadius + 12) * cos;
    const my = cy + (outerRadius + 12) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 10;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke="#cbd5e1" fill="none" strokeWidth={1} />
            <text
                x={ex + (cos >= 0 ? 1 : -1) * 4}
                y={ey}
                textAnchor={textAnchor}
                fill="#475569"
                dominantBaseline="central"
                fontSize={10}
                fontWeight={700}
            >
                {formatPercentage(percent * 100)}
            </text>
        </g>
    );
};
